export default __webpack_public_path__ + "1246e0c28686c8695e56c26931f73bb1.png";